import {all, fork} from "redux-saga/effects";
import {put, takeEvery} from "@redux-saga/core/effects";
import {
    getAllElement,
    getAllElementError,
    GetAllElementPayloaTreatment,
    getAllElementSuccess, handleComplete, handleCompleteError, handleCompleteSuccess
} from "../reducers/Treatment/TreatmentReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {PayloadAction} from "@reduxjs/toolkit";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";


function* getAllElementSaga() {
    yield takeEvery(getAllElement.type, function* (action: PayloadAction<GetAllElementPayloaTreatment>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({ type: getAllElementError.type });
            return;
        }

        const { pageableDto } = action.payload;

        try {
            let response: CustomFetchResponse = yield CustomFetch({
                method: "POST",
                url: apiPaths.visualTreatmentExpired,
                authenticated: true,
                data: pageableDto,
            });

            if (response.status === 200) {
                yield put({ type: getAllElementSuccess.type, payload: response.data });

            } else {
                yield put({ type: getAllElementError.type });
            }
        } catch (error) {
            console.error("Error in getAllElementSaga:", error);
            yield put({ type: getAllElementError.type });
        }
    });
}
function* setCheckComplete() {
    yield takeEvery(handleComplete.type, function* (action:PayloadAction<{id: string, callback : () => void}>) {
        const url = `${apiPaths.setCheckComplete}/${action.payload.id}`

        let response: CustomFetchResponse = yield CustomFetch({
            method: "PUT",
            url: url,
            authenticated: true,
            data: action.payload
        })


        if(response.status === 200){


            yield put({type: handleCompleteSuccess.type, payload: response.data.content})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Elemento modificato correttamento',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            action.payload.callback()
        } else {
            yield put({ type: handleCompleteError.type });
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Elemento non modificato',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }

    })
}


/*function* saveElementSaga(){
    yield takeEvery(saveElement.type, function* (action: PayloadAction<{ treatment: TreatmentElement , callback : () => void}>) {
              const savePayload = {
                  notes: action.payload.treatment.notes,
                  dogId: action.payload.treatment.dogId,
                  executionDate: action.payload.treatment.executionDate,
                  multimedias: action.payload.treatment.multimedias
              }

        let response: CustomFetchResponse = yield CustomFetch({method: "POST", url: apiPaths.saveTreatments, authenticated: true, data: action.payload})
        if (response.status === 200){
            yield put({type: saveElementSuccess.type, payload: response.data})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element added successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            action.payload.callback()
        } else {
            yield put({type: saveElementError.type})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element not added',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            })
        }


    })
}



function* deleteElementSaga() {
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<{id:string,callback: () => void}>) {
        const url = `${apiPaths.deleteTreatments}/${action.payload.id}`
        let response: CustomFetchResponse = yield CustomFetch({
            method: "DELETE",
            url: url,
            authenticated: true,
            data: action.payload})

        if(response.status === 200){

            action.payload.callback()
            yield put({type: deleteElementSuccess.type, payload: response.data.content})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element deleted successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            yield put({type: getAllElement.type})

        } else {
            yield put({ type: deleteElementError.type });
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element not deleted',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }
    })
}

function* updateElementSaga() {
    yield takeEvery(updateElement.type, function* (action: PayloadAction<{ treatment: TreatmentElement , callback : () => void}>) {

        const url = `${apiPaths.updateTreatments}/${action.payload.treatment._id}`
        let response: CustomFetchResponse = yield CustomFetch({method: "PUT",
            url: url,
            authenticated:true ,
            data: action.payload
        })



        if (response.status === 200){
            yield put ({
                type: updateElementSuccess.type,
                payload: response.data
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element update',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })

            action.payload.callback()
        }
        else {
            yield put ({
                type: updateElementError.type,
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element not update',
                    variant: 'alert',
                    alert: {
                        color: 'warning'
                    }
                }
            })
        }
    });

    yield put({
        type: updateElementSuccess.type,
        payload: actions.payload
    })
    yield put({
        type: openSnackbar.type, payload: {
            open: true,
            message: 'Element updated successfully',
            variant: 'alert',
            alert: {
                color: 'success'
            }
        }
    })
}*/

export default function* Treatment() {
    yield all(
        [
            fork(getAllElementSaga),
            fork(setCheckComplete),
      /*      fork(saveElementSaga),
            fork(updateElementSaga),
            fork(deleteElementSaga)*/
        ]
    )

}